module.exports = __webpack_public_path__ + "img/5.7d469f80.svg";